// The one product card (snippets/product-card.liquid): option choice -> variant (price, compare-at price, badges,
// image, button, minimum quantity, unavailable options), quantity buttons and the image carousel arrows.
// Add to cart posts the card's form; assets/cart-drawer.js catches /cart/add and opens the drawer.
(() => {
  if (window.themeProductCard) return;
  window.themeProductCard = true;

  const variants = (card) => {
    if (!card.pcVariants) {
      try { card.pcVariants = JSON.parse(card.querySelector('[data-pc-variants]')?.textContent || '[]'); } catch { card.pcVariants = []; }
    }
    return card.pcVariants;
  };

  const chosen = (card) => {
    const values = [];
    card.querySelectorAll('[data-pc-option]').forEach((input) => {
      if (input.tagName === 'SELECT' || input.checked) values[Number(input.dataset.pcOption)] = input.value;
    });
    return values;
  };

  const money = (card, cents) => window.theme.formatMoney(cents, card.dataset.moneyFormat);

  const showSlide = (card, index) => {
    const slides = [...card.querySelectorAll('.pcard__slide')];
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === next));
    card.pcSlide = next;
  };

  // Marks option values that have no available variant with the other current choices.
  const markAvailability = (card, values) => {
    const list = variants(card);
    card.querySelectorAll('[data-pc-option]').forEach((input) => {
      const position = Number(input.dataset.pcOption);
      const options = input.tagName === 'SELECT' ? [...input.options] : [input];
      options.forEach((option) => {
        const test = [...values];
        test[position] = option.value;
        const match = list.find((v) => v.options.every((value, i) => test[i] === undefined || test[i] === value));
        const state = !match ? 'missing' : match.available ? 'available' : 'sold-out';
        (option.closest('.pcard__pill') || option).dataset.state = state;
        // Unavailable variants: Hide (pills are hidden in CSS; a dropdown option needs the hidden property)
        if (option.tagName === 'OPTION') option.hidden = state !== 'available' && input.closest('[data-unavailable]')?.dataset.unavailable === 'hide';
      });
    });
  };

  const update = (card) => {
    const values = chosen(card);
    const variant = variants(card).find((v) => v.options.every((value, i) => values[i] === value));
    markAvailability(card, values);
    const button = card.querySelector('[data-pc-submit]');
    const label = card.querySelector('[data-pc-label]');
    if (!variant) {
      if (button) button.disabled = true;
      return;
    }
    const onSale = variant.compare > variant.price;
    card.querySelectorAll('[data-pc-id]').forEach((input) => { input.value = variant.id; });
    const price = card.querySelector('[data-pc-price]');
    if (price) { price.textContent = money(card, variant.price); price.classList.toggle('pcard__current--sale', onSale); }
    const compare = card.querySelector('[data-pc-compare]');
    if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? money(card, variant.compare) : ''; }
    const sale = card.querySelector('[data-pc-sale]');
    if (sale) {
      sale.hidden = !(onSale && variant.available);
      const saved = variant.compare - variant.price;
      const kind = card.dataset.badgeValue;
      if (onSale) sale.textContent = kind === 'custom' ? card.dataset.badgeText
        : kind === 'amount' ? `${money(card, saved).replace(/[.,]00(?=\D*$)/, '')} ${card.dataset.badgeLabel}`
        : `${Math.round((saved * 100) / variant.compare)}% ${card.dataset.badgeLabel}`;
    }
    const sold = card.querySelector('[data-pc-sold]');
    if (sold) sold.hidden = variant.available;
    if (button) button.disabled = !variant.available;
    if (label) label.textContent = variant.available ? label.dataset.label : label.dataset.soldOut;
    const quantity = card.querySelector('[data-pc-quantity]');
    if (quantity) { quantity.min = variant.min; if (Number(quantity.value) < variant.min) quantity.value = variant.min; }
    if (variant.position) showSlide(card, variant.position - 1);
    const main = card.querySelector('.pcard__image:not(.pcard__image--hover)');
    if (main && variant.src) { main.removeAttribute('srcset'); main.src = variant.src; }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-pc-option]')) return;
    const card = event.target.closest('[data-product-card]');
    if (card) update(card);
  });

  document.addEventListener('click', (event) => {
    const qty = event.target.closest('[data-pc-qty]');
    if (qty) {
      const input = qty.parentElement.querySelector('[data-pc-quantity]');
      const min = Number(input.min) || 1;
      input.value = Math.max(min, (Number(input.value) || min) + Number(qty.dataset.pcQty));
      return;
    }
    const step = event.target.closest('[data-pc-step]');
    if (step) {
      event.preventDefault();
      const card = step.closest('[data-product-card]');
      showSlide(card, (card.pcSlide || 0) + Number(step.dataset.pcStep));
    }
  });

  const init = (root = document) => root.querySelectorAll('[data-product-card]').forEach((card) => {
    if (card.querySelector('[data-pc-option]')) markAvailability(card, chosen(card));
  });
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
